module.exports = __webpack_public_path__ + "img/v-line-sm.9f77d87e.svg";